const Reports = () => import(/* webpackChunkName: "Reports" */ "./pages/Reports/Reports.vue");
const ListReports = () => import(/* webpackChunkName: "ListReports" */ "./pages/Reports/overview/ListReports");
const ReportDetails = () => import(/* webpackChunkName: "ReportDetails" */ "./pages/Reports/overview/ReportDetails");
const FileUpload = () => import(/* webpackChunkName: "FileUpload" */ "./pages/FileUpload/FileUpload.vue");
const FileUploadPage = () =>
    import(/* webpackChunkName: "FileUploadPage" */ "./pages/FileUpload/upload/FileUploadPage.vue");
const ReportRelease = () =>
    import(/* webpackChunkName: "ReportRelease" */ "./pages/FileUpload/release/ReportRelease.vue");

const pages = [
    {
        path: "/",
        redirect: "/file-upload/upload",
    },
    {
        path: "/reports",
        name: "Reports",
        slug: "reports",
        component: Reports,
        children: [
            {
                path: "",
                redirect: "/reports/overview",
            },
            {
                path: "overview",
                name: "ListReports",
                slug: "list-reports",
                component: ListReports,
            },
            {
                path: "details/:reportId",
                name: "ReportDetails",
                slug: "report-details",
                component: ReportDetails,
                props: true,
            },
        ],
    },
    {
        path: "/file-upload",
        name: "FileUpload",
        slug: "file-upload",
        component: FileUpload,
        children: [
            {
                path: "",
                redirect: "/file-upload/upload",
            },
            {
                path: "upload",
                name: "FileUploadPage",
                slug: "file-upload-page",
                component: FileUploadPage,
            },
            {
                path: "report-release",
                name: "ReportRelease",
                slug: "report-release",
                component: ReportRelease,
            },
        ],
    },
];

export { pages };
